import { colorFromThresholds } from "../../../utils/tone";

export function ReadinessRing({
  value = 84,
  size = 24,
}: {
  value?: number;
  size?: number;
}) {
  const r = (size - 4) / 2;
  const C = 2 * Math.PI * r;
  const dash = (value / 100) * C;
  const color = colorFromThresholds(value);
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="var(--line)"
        strokeWidth={2}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeDasharray={`${dash} ${C}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}
